import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SignInRes;
export const SignInTodo = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/user_login',
            data: {
                "username": data.username,
                "password": data.password,
                "role": data.role,
                "device_token": ""
            },
            headers: { "Content-Type": "application/json" }
        })
        return SignInRes = res.data
    } catch (error) {
        return SignInRes = error.response.data
    }
})